// extracted by mini-css-extract-plugin
module.exports = {"container":"Expandable_container__3RyQx","item":"Expandable_item__2GTb5","hypen":"Expandable_hypen__1KxDP"};